import React, { useState,useEffect } from 'react'
import { useLocation } from 'react-router-dom';

const EmailConfirmedComponent = () => {

    const [nameUrl,setNameUrl] = useState("")
    const [statusUrl,setStatusUrl] = useState("")

    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    let query = useQuery()

    useEffect( () => {
        setNameUrl(query.get("name"))
        setStatusUrl(query.get("status"))   
    },[query])

    return(
        <section className="message message-section">
            <div className="container " style= {{marginTop: "15rem",  marginBottom: "5rem"}}>
                <div className="description" >
                    <p style={{ marginBottom: "20px"}}>Здравейте {nameUrl},</p>
                    { (statusUrl === "success") && <p >Потвърждението на Вашия имайл е успешно!</p> }
                    { (statusUrl === "fail") && <p>Вашият имейл Не беше потвърден, моля опитайте отново или се свържете с нас!</p> }
                </div>
            </div>
    </section>
    )

};

export default EmailConfirmedComponent;